import type { Ref } from '@vue/composition-api';
import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';
import type { NodeVisibilityPayload } from '../../editor-wrapper/tracking/types/node-tracking';

export const useTrackingStore = defineStore('tracking', () => {
  const revision: Ref<number> = ref(null);
  const visibleSections: Ref<string[]> = ref([]);
  const visibleBlock = ref('');

  const setRevision = (newRevision: number) => {
    revision.value = newRevision;
  };

  const setVisibleSections = ({ visible, editorBlockId, sectionId }: NodeVisibilityPayload) => {
    setVisiblePage(editorBlockId);

    if (visible) {
      visibleSections.value = [...visibleSections.value, sectionId];
    } else {
      visibleSections.value = visibleSections.value.filter(id => id !== sectionId);
    }
  };

  const setVisiblePage = (id: string) => {
    if (visibleBlock.value !== id) {
      visibleSections.value = [];
    }
    visibleBlock.value = id;
  };

  const reset = () => {
    revision.value = null;
    visibleSections.value = [];
    visibleBlock.value = '';
  };

  return {
    setRevision,
    setVisibleSections,
    revision,
    visibleSections,
    reset,
  };
});
